module.exports = __webpack_public_path__ + "static/Portrait_Luzia_Johow-83452e0bcefab79e745c66e0f2c4f5ff.jpg";